import { render, staticRenderFns } from "./AlterarSenha.vue?vue&type=template&id=5f2aafd9&scoped=true"
import script from "./AlterarSenha.vue?vue&type=script&lang=js"
export * from "./AlterarSenha.vue?vue&type=script&lang=js"
import style0 from "./AlterarSenha.vue?vue&type=style&index=0&id=5f2aafd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2aafd9",
  null
  
)

export default component.exports